<template>
    <div>
        <v-dialog v-model="open" v-if="open" persistent scrollable max-width="920px" min-height="500px">
            <v-card>
                <v-app-bar flat dark color="primary">
                    <v-app-bar-nav-icon v-if="!isNotMobile" @click.stop="showMenu = !showMenu"></v-app-bar-nav-icon>
                    <span v-if="textHeader">{{ textHeader }}</span>
                    <v-toolbar-items v-if="isNotMobile">
                        <v-btn :class="{ 'blue darken-3 ': showModal == 1 ? true : false }" dark text @click.native="activeClick(1)">CLIENTE</v-btn>
                        <v-btn :class="{ 'blue darken-3 ': showModal == 2 ? true : false }" @click.native="activeClick(2)" text>PRODUCTO</v-btn>
                        <v-btn :class="{ 'blue darken-3 ': showModal == 3 ? true : false }" @click.native="activeClick(3)" text>DATOS DE ENVÍO</v-btn>
                        <v-btn v-if="roles != 'COMUNITY'" :class="{ 'blue darken-3 ': showModal == 4 ? true : false }" @click.native="activeClick(4)" text
                            >ESTADOS</v-btn
                        >
                    </v-toolbar-items>

                    <v-menu v-else v-model="showMenu" transition="slide-y-transition" bottom>
                        <v-list class="blue">
                            <v-list-item dark :class="{ 'blue darken-3 ': showModal == 1 ? true : false }" @click.native="activeClick(1, 'CLIENTE')">
                                <v-list-item-title>CLIENTE</v-list-item-title>
                            </v-list-item>
                            <v-list-item dark :class="{ 'blue darken-3 ': showModal == 2 ? true : false }" @click.native="activeClick(2, 'PRODUCTO')">
                                <v-list-item-title>PRODUCTO</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="roles != 'COMUNITY'"
                                dark
                                :class="{ 'blue darken-3 ': showModal == 3 ? true : false }"
                                @click.native="activeClick(3, 'DATOS DE ENVÍO')"
                            >
                                <v-list-item-title>DATOS DE ENVÍO</v-list-item-title>
                            </v-list-item>
                            <v-list-item dark :class="{ 'blue darken-3 ': showModal == 4 ? true : false }" @click.native="activeClick(4, 'ESTADOS')">
                                <v-list-item-title>ESTADOS</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-spacer></v-spacer>
                    <v-chip small color="secondaryTheme" v-if="datos.idProspecto" class="caption pl-3" dark>N° {{ datos.idProspecto }}</v-chip>
                    <v-btn small class="blue darken-4 mx-2" icon @click.native="cerrarModal"> <v-icon small>mdi-close</v-icon> </v-btn>
                </v-app-bar>
                <v-divider></v-divider>
                <v-card-text class="mainText">
                    <!-- <v-container> -->
                    <v-row dense class="py-2">
                        <v-col cols="12">
                            <v-container>
                                <template v-if="showModal === 1">
                                    <v-row align="center">
                                        <v-col cols="12" sm="6" md="3">
                                            <v-select
                                                clearable
                                                v-model="datos.idTipoDocumento"
                                                v-validate="'required'"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="tipoDocumento"
                                                item-text="text"
                                                item-value="id"
                                                :error-messages="errors.collect('datos.idTipoDocumento')"
                                                label="Tipo de documento*"
                                                data-vv-name="datos.idTipoDocumento"
                                                data-vv-as="Tipo"
                                                required
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                                v-model="datos.numeroDocumento"
                                                v-validate="'required'"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                label="Nro Documento*"
                                                :error-messages="errors.collect('datos.numeroDocumento')"
                                                data-vv-name="datos.numeroDocumento"
                                                data-vv-as="documento"
                                                required
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                                v-model="datos.nombreCompletos"
                                                v-validate="'required'"
                                                dense
                                                outlined
                                                hide-details="auto"
                                                label="Nombres*"
                                                :error-messages="errors.collect('datos.nombreCompletos')"
                                                data-vv-name="datos.nombreCompletos"
                                                data-vv-as="nombres"
                                                required
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                                :error-messages="errors.collect('datos.telefono')"
                                                v-validate="'required'"
                                                data-vv-name="datos.telefono"
                                                data-vv-as="telefono"
                                                v-model="datos.telefono"
                                                hide-details="auto"
                                                dense
                                                outlined
                                                label="Telefono* "
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                                v-validate="'email'"
                                                :error-messages="errors.collect('datos.correo')"
                                                data-vv-name="correo"
                                                v-model="datos.correo"
                                                hide-details="auto"
                                                dense
                                                outlined
                                                label="Correo"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-model="datos.idOrigen"
                                                v-validate="'required'"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="listaOrigen"
                                                item-text="origen"
                                                item-value="idOrigen"
                                                :error-messages="errors.collect('datos.idOrigen')"
                                                label="Asignar Origen*"
                                                data-vv-name="datos.idOrigen"
                                                data-vv-as="Origen"
                                                required
                                            >
                                                <template v-slot:item="data">
                                                    <v-chip small color="secondaryTheme" class="caption px-2" dark>{{ data.item.canal }}</v-chip>
                                                    &nbsp;&nbsp;<span class="caption">{{ data.item.origen }} </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('datos.idDepa')"
                                                data-vv-name="datos.idDepa"
                                                data-vv-as="departamento"
                                                v-model="datos.idDepa"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="departamentoAssign"
                                                item-text="descripcion"
                                                item-value="idDepa"
                                                label="Departamento*"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-validate="'required'"
                                                :error-messages="errors.collect('datos.idProv')"
                                                data-vv-name="datos.idProv"
                                                data-vv-as="provincia"
                                                v-model="datos.idProv"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="provincias"
                                                item-text="descripcion"
                                                item-value="idProv"
                                                label="Provincia*"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-model="datos.idDist"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="distritos"
                                                item-text="descripcion"
                                                item-value="idDist"
                                                label="Distrito"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field v-model="datos.direccion" hide-details="auto" dense outlined label="Dirección" />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field v-model="datos.telefono2" hide-details="auto" dense outlined label="Telefono 2" />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field v-model="datos.correo2" hide-details="auto" dense outlined label="Correo 2" />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="showModal === 2">
                                    <v-row align="center">
                                        <v-col cols="12" sm="6" md="3">
                                            <v-select
                                                clearable
                                                v-model="datos.idTipoProspecto"
                                                v-validate="'required'"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="tipoProspecto"
                                                item-text="text"
                                                item-value="id"
                                                :error-messages="errors.collect('datos.idTipoProspecto')"
                                                label="Tipo de Compra*"
                                                data-vv-name="datos.idTipoProspecto"
                                                data-vv-as="Tipo"
                                                required
                                            />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                v-model="datos.idMarca"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="_filterListMarca"
                                                item-text="descripcion"
                                                item-value="id"
                                                label="Seleccionar Marca"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3" v-if="idTipoProspecto == 3 && datos.idMarca == 13">
                                            <v-text-field v-model="datos.marcaOrigen" dense hide-details="auto" outlined label="Marca Origen" />
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3" v-if="idTipoProspecto == 3">
                                            <v-text-field v-model="datos.modeloOrigen" dense hide-details="auto" outlined label="Modelo Origen" />
                                        </v-col>

                                        <v-col cols="12" sm="6" md="3" v-else>
                                            <v-autocomplete
                                                clearable
                                                v-model="datos.idModelo"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="_filterListModelo"
                                                item-text="descripcion"
                                                item-value="id"
                                                label="Modelo"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select
                                                clearable
                                                v-model="datos.idTipoPago"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="tipoPago"
                                                item-text="text"
                                                item-value="id"
                                                label="Tipo de Pago"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                auto-grow
                                                rows="3"
                                                row-height="30"
                                                v-model="datos.descripcion"
                                                v-validate="'required'"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                label="Consulta*"
                                                :error-messages="errors.collect('datos.descripcion')"
                                                data-vv-name="datos.descripcion"
                                                required
                                            />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="showModal === 3">
                                    <v-row align="center">
                                        <v-col cols="12">
                                            <v-checkbox
                                                dense
                                                v-model="datos.isEnvioCliente"
                                                hide-details="auto"
                                                :label="`Tenemos datos de Envío?`"
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>

                                    <v-row align="center" v-if="datos.isEnvioCliente">
                                        <v-col cols="12" sm="6" md="3">
                                            <v-select
                                                clearable
                                                v-model="datos.idMetodoEnvio"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="metodoEnvio"
                                                item-text="text"
                                                item-value="id"
                                                label="Tipo de Envio"
                                            />
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-model="datos.idDepa"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="departamentoAssign"
                                                item-text="descripcion"
                                                item-value="idDepa"
                                                label="Departamento"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-model="datos.idProv"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="provincias"
                                                item-text="descripcion"
                                                item-value="idProv"
                                                label="Provincia"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-autocomplete
                                                clearable
                                                autocomplete="off"
                                                v-model="datos.idDist"
                                                dense
                                                hide-details="auto"
                                                outlined
                                                :items="distritos"
                                                item-text="descripcion"
                                                item-value="idDist"
                                                label="Distrito"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field v-model="datos.direccion" hide-details="auto" dense outlined label="Dirección" />
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="showModal === 4">
                                    <template v-if="loadingItems"><ItemEstados :step="step" /> </template>
                                    <template v-else>
                                        <v-progress-circular :size="50" color="primary" indeterminate> </v-progress-circular>
                                    </template>
                                </template>
                            </v-container>
                        </v-col>
                    </v-row>
                    <!-- </v-container> -->
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions class="grey lighten-2" align="center" justify="center">
                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-row>
                                <v-col cols="6" sm="4"> <v-btn small color="primary" :loading="loading" dark @click="downStep">Atras</v-btn> </v-col>
                                <template v-if="showNext">
                                    <v-col cols="6" :sm="showModal > 1 ? 4 : 8">
                                        <v-btn small color="primary" :loading="loadingStep" dark @click="nextStep">Siguiente</v-btn>
                                    </v-col>
                                </template>
                                <template v-if="showModal > 1">
                                    <v-col cols="6" sm="4">
                                        <v-btn color="green" small :loading="loadingRegistro" dark @click="nextAction">{{ textBTN }}</v-btn>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openConfirmation" persistent max-width="360px" min-height="400px">
            <v-card class="blue darken-1">
                <v-app-bar flat dark color="primary">
                    <span class="white--text title" color="white">¿Desea Registrar más datos?</span>
                    <v-spacer></v-spacer>
                    <v-btn small class="blue darken-4" icon @click="closeModalConfirm"> <v-icon small>mdi-close</v-icon> </v-btn>
                </v-app-bar>

                <v-card-actions class="blue-grey lighten-3">
                    <v-spacer />
                    <!-- <v-btn color="green" :disabled="roles[0] == 'COMUNITY'" :loading="loadingContinuar" @click="createRegistro(true, 'loadingContinuar')" -->
                    <v-btn color="orange" :disabled="roles[0] == 'COMUNITY'" :loading="loadingContinuar" @click="createRegistro(true, 'loadingContinuar')">
                        Continuar</v-btn
                    >
                    <v-btn color="green" dark :loading="loadingConfirmation" @click="createRegistro(false, 'loadingConfirmation')">Finalizar</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openModalContinue" persistent max-width="360px" min-height="400px">
            <v-card class="blue darken-1">
                <v-app-bar flat dark color="primary">
                    <span class="white--text title" color="white">¿Continuar editando?</span>
                    <v-spacer></v-spacer>
                    <v-btn small class="blue darken-4" icon @click="closeModalContinue(1)"> <v-icon small>mdi-close</v-icon> </v-btn>
                </v-app-bar>
                <v-card-actions class="blue-grey lighten-3">
                    <v-spacer />
                    <!-- <v-btn color="green" :disabled="roles[0] == 'COMUNITY'" :loading="loadingContinuar" @click="createRegistro(true, 'loadingContinuar')" -->
                    <v-btn color="orange" :disabled="roles[0] == 'COMUNITY'" :loading="loadingContinuar" @click="closeModalContinue(1)"> si</v-btn>
                    <v-btn color="green" dark :loading="loadingConfirmation" @click="closeModalContinue(2)">NO</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import ItemEstados from '@/components/crud/ItemEstados'

export default {
    props: ['open', 'loadingBTN', 'textButton', 'step'],
    mixins: [mixins],
    components: {
        ItemEstados
    },
    data() {
        return {
            openModalContinue: false,
            showMenu: false,
            openConfirmation: false,
            loadingStep: false,
            showModal: 1,
            loadingItems: true,
            loading: false,
            textHeader: '',

            loadingRegistro: false,
            loadingConfirmation: false,
            loadingContinuar: false,

            tipoProspecto: [
                { id: 1, text: 'Primera Compra' },
                { id: 2, text: 'Recurrente' },
                { id: 3, text: 'Cambio de Marca' }
            ],
            tipoPago: [
                { id: 3, text: 'Tarjeta' },
                { id: 4, text: 'Efectivo' },
                { id: 5, text: 'Transferencia' },
                { id: 6, text: 'Financiamiento' }
            ]
        }
    },
    computed: {
        ...mapGetters({
            listaProductos: 'productos/lista',
            listaEstados: 'estados/lista',
            optionalRole: 'usuarios/optionalRole',
            departamentoAssign: 'ubigeo/departamentoAssign'
        }),
        ...mapGetters('prospectos', ['lista']),
        ...mapState('prospectos', ['datos']),

        ...mapState('productos', ['listaMarca']),

        ...mapState('ubigeo', ['provincias', 'distritos']),
        ...mapState('usuarios', ['listaOrigen', 'userLogin', 'roles']),
        ...mapState('utilities', ['tipoDocumento', 'metodoEnvio']),
        idTipoProspecto() {
            return this.datos.idTipoProspecto
        },
        idMarca() {
            console.log('this.datos.idMarca ', this.datos.idMarca)
            return this.datos.idMarca
        },
        idModelo() {
            console.log('this.datos.idModelo ', this.datos.idModelo)
            return this.datos.idModelo
        },
        isDepartamento() {
            return this.datos.idDepa
        },
        isProvincia() {
            return this.datos.idProv
        },
        isDistrito() {
            return this.datos.idDist
        },
        isEnvioCliente() {
            return this.datos.isEnvioCliente
        },
        textBTN() {
            return this.step == 2 ? 'Actualizar' : 'CONTINUAR'
        },
        _filterListModelo() {
            if (this.datos.idMarca) {
                return this.listaProductos.filter((x) => x.idMarca == this.datos.idMarca)
            } else {
                return []
            }
        },
        _filterListMarca() {
            let idTipoMarca = this.idTipoProspecto == 1 || this.idTipoProspecto == 2 ? 1 : 2
            if (idTipoMarca) {
                return this.listaMarca.filter((x) => x.idTipoMarca == idTipoMarca)
            } else {
                return []
            }
        },
        isNotMobile() {
            if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
                return false
            } else {
                return true
            }
        },
        showNext() {
            if (this.showModal == 4) {
                return false
            } else if (this.showModal == 2) {
                if (this.step == 2) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        }
    },
    watch: {
        async idMarca() {
            console.log('watch this.datos.idMarca', this.datos.idMarca)
            await this.handleGetProducto()
        },

        async showModal(val) {
            console.log('val ', val, this.step)

            if (val == 2) {
                //this.loadingItems = false
                let tipo = this.idTipoProspecto == 1 || this.idTipoProspecto == 2 ? 1 : 2
                await this.handleGetMarcas(tipo)
            } else if (val == 3) {
                /* if (this.step == 1) {
                    this.openConfirmation = true
                } */
            } else if (val == 4) {
                await this.fnHandleGet({})
            }
        },
        isEnvioCliente(val) {
            if (val) {
                this.UPDATE_DATOS({
                    idDistritoEnvio: this.datos.idDistrito,
                    idDepartamentoEnvio: this.datos.departamento,
                    idProvinciaEnvio: this.datos.provincia,
                    direccionEnvio: this.datos.direccion
                })
            } else {
                this.UPDATE_DATOS({
                    idDistritoEnvio: null,
                    idDepartamentoEnvio: null,
                    idProvinciaEnvio: null,
                    direccionEnvio: null
                })
            }
        },
        async isDepartamento(val) {
            console.log('isDepartamento ', val)
            if (val) {
                await this.handleGetProvincias({ id: val })
                if (this.step == 1) {
                    this.UPDATE_DATOS({
                        idDistrito: null
                    })
                }
            }
        },
        async isProvincia(val, old) {
            console.log('isProvincia ', val, ' old ', old)
            if (val) {
                await this.handleGetDistritos({ id: val })
            }
        }
    },
    methods: {
        ...mapMutations({
            UPDATE_DATOS: 'prospectos/UPDATE_DATOS',
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        ...mapActions({
            handleGetDepartamentos: 'ubigeo/obtenerListaDepartamentos',
            handleGetProvincias: 'ubigeo/obtenerListaPronvincias',
            handleGetDistritos: 'ubigeo/obtenerListaDistritos',
            handleGetProducto: 'productos/obtenerLista',
            handleGetEstados: 'estados/obtenerLista',
            handleGetOrigen: 'origen/obtenerLista',
            handleCrearRegistro: 'prospectos/registrarProspecto',
            handleCrearClientes: 'clientes/registrar',
            handleActualizarClientes: 'clientes/actualizar',
            handleActualizarRegistro: 'prospectos/actualizarProspecto',
            handleGetMarcas: 'productos/getMarcas'
        }),

        closeModalConfirm() {
            this.openConfirmation = false
        },
        nextAction() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    if (this.roles[0] == 'ASESOR' && this.optionalRole.create) {
                        this.UPDATE_DATOS({
                            usuarioCreacion: this.userLogin.usuario,
                            usuarioModificacion: this.userLogin.usuario
                        })
                    }
                    if (this.step == 2) {
                        await this.updateRegistro({ closeModal: true })
                    } else {
                        console.log('this.roles ', this.roles)
                        console.log('userLogin ', this.optionalRole)
                        if (this.optionalRole.create || this.roles[0] == 'SUPERADMIN') {
                            if (this.showModal > 2) {
                                await this.updateRegistro({ closeModal: false })
                            } else {
                                this.openConfirmation = true
                            }
                        }
                    }
                }
            })
        },
        async fnHandleGet({ numeroDocumento = null, idCanal = null, idOrigen = null, usuario = null }) {
            await this.handleGetEstados({ status: false })
        },
        async createRegistro(val, labelLoading) {
            this[labelLoading] = true
            this.UPDATE_DATOS({
                idDistritoEnvio: this.datos.idDistritoEnvio,
                idDistrito: this.datos.idDistritoEnvio
            })
            const item = await this.handleCrearRegistro(this.datos)
            this.UPDATE_DATOS({ ...this.datos, idProspecto: item.payload.idProspecto, idPersona: item.payload.idPersona })
            this[labelLoading] = false
            this.openConfirmation = false
            if (!val) {
                // si le da click a finalizar
                this.cerrarModal()
                await this.$emit('reload')
                return
            } else {
                this.showModal = this.showModal + 1
            }
            console.log('here-1')
        },
        async cerrarModal() {
            this.showModal = 1
            await this.$emit('closeModal', 'openDialog')
        },
        async updateRegistro(payload) {
            console.log('close /update ', payload['closeModal'])
            this.loadingRegistro = true
            console.log('this.datos ', this.datos)
            await this.handleActualizarRegistro(this.datos)
            this.loadingRegistro = false
            this.openModalContinue = true
            // await this.$emit('closeModal', 'openDialog')
        },
        async closeModalContinue(tipo) {
            this.openModalContinue = false
            if (tipo == 2) {
                this.cerrarModal()
                await this.$emit('reload')
            }
        },
        nextStep() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    this.loadingStep = true
                    const val = 1 + this.showModal
                    console.log('val ', val)
                    if (val == 2) {
                        if (this.step == 1 && !this.datos.idPersona) {
                            console.log('here-1')
                            //Create person
                            const per = await this.handleCrearClientes(this.datos)
                            this.UPDATE_DATOS({
                                idPersona: per.payload
                            })
                        } else {
                            //Update person
                            console.log("this.datos",this.datos)
                            await this.handleActualizarClientes({
                                ...this.datos,
                                id: this.datos.idPersona
                            })
                        }
                    }
                    if (val === 5) {
                        this.showModal = 1
                    } else {
                        this.showModal = val
                    }
                    this.loadingStep = false
                }
            })
        },
        activeClick(header, text) {
            this.textHeader = text
            console.log('here--------', header)
            if (this.step == 2) {
                this.showModal = header
            }
        },
        downStep() {
            const val = this.showModal - 1
            if (val === 0) {
                this.showModal = 1
            } else {
                this.showModal = val
            }
        }
    },
    async mounted() {
        console.log('CREATED_MODAL', this.datos)
        //
        this.textHeader = null
        this.showMenu = false
        const idDepa = this.datos.idDepa
        const idProv = this.datos.idProv
        const idDist = this.datos.idDist
        const idTipoProspecto = this.datos.idTipoProspecto
        const idMarca = this.datos.idMarca
        const idModelo = this.datos.idModelo

        await this.handleGetDepartamentos()
        if (this.step == 2) {
            if (idProv) {
                await this.handleGetProvincias({ id: idDepa })
            }
            if (idDist) {
                await this.handleGetDistritos({ id: idProv })
            }
            if (idTipoProspecto) {
                await this.handleGetMarcas()
            }
            await this.handleGetProducto()
            if (idModelo) {
                const listaFind = this.listaProductos.find((x) => x.id == idModelo)
                this.datos.idMarca = listaFind ? listaFind.idMarca : null
            }
        }
    }
}
</script>
